var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24918_75862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.43842 10.2305L1.5835 13.7194L4.22238 14.2472L5.27794 17.4139L8.05335 13.0101",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5617 10.2305L17.4166 13.7194L14.7777 14.2472L13.7222 17.4139L10.9468 13.0101",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69482 7.38759C3.69482 8.92732 4.30648 10.404 5.39523 11.4927C6.48399 12.5815 7.96065 13.1931 9.50038 13.1931C11.0401 13.1931 12.5168 12.5815 13.6055 11.4927C14.6943 10.404 15.3059 8.92732 15.3059 7.38759C15.3059 5.84786 14.6943 4.37119 13.6055 3.28244C12.5168 2.19369 11.0401 1.58203 9.50038 1.58203C7.96065 1.58203 6.48399 2.19369 5.39523 3.28244C4.30648 4.37119 3.69482 5.84786 3.69482 7.38759V7.38759Z",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24918_75862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/Badge.4f67899a.svg";
export { ForwardRef as ReactComponent };